import React from 'react'
import { View } from 'react-native'
import { Divider } from '@ui-kitten/components'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Pill, Text } from '@components/base'
import { UiPillType } from '@src/types'

/**
 * Renders the "Gut Microbiome Test - OUT OF STOCK" line item shown on
 * checkout when the user added the microbiome offer in the upstream
 * `MicrobiomeTest` step. Reused by both `DietitianMenuCheckout` (one-time
 * lab purchases) and `SubscriptionCheckout` (recurring lab purchases).
 */
export const MicrobiomeOutOfStockNotice = () => {
  const styles = useStyleSheet(themedStyle)

  return (
    <>
      <Divider />
      <View style={styles.container}>
        <View style={styles.details}>
          <Text type="regular" bold>
            Gut Microbiome Test
          </Text>
          <Text type="small" lineSpacing="tight">
            Out of stock and has been removed from your cart. We will notify you when it’s available
          </Text>
        </View>
        <Pill
          text="OUT OF STOCK"
          status={UiPillType.Alert}
          size="s"
          textBold={false}
          textType="small"
        />
      </View>
    </>
  )
}

const themedStyle = StyleService.create({
  container: {
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  details: {
    flex: 1,
    gap: 8,
  },
})
